enum FeedbackQuestionTypes {
  Text,
  Numeric,
  Select,
  Slider,
}

export default FeedbackQuestionTypes;
